import styled from "styled-components";

export const Container = styled.section`
  background-color: ${(props) => props.theme.colors.GREY_1};

  > * {
    background: ${(props) => props.theme.colors.WHITE};
  }
`;

export const Main = styled.div`
  padding: 5rem 4%;
  ${(props) => props.theme.css.TOP_SHADOW}
`;

export const TopBar = styled.div`
  background-color: ${(props) => props.theme.colors.WHITE};
  height: 12rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;
  ${(props) => props.theme.css.BOTTOM_SHADOW}

  h1 {
    font-size: 4rem;
    color: ${(props) => props.theme.colors.TEXT_GREY};
  }
`;

export const BodyContainer = styled.div`
  padding-top: 12rem;
`;
